module.exports = __webpack_public_path__ + "static/media/nims.f64d59b0.png";